import React from 'react';
import styled, { css } from 'styled-components';

import { layout, media } from '@prisjakt/ui-base';

type Props = {
  children?: React.ReactNode;
  containerProps?: {};
  onMount?: () => void;
  wrap?: boolean;
  wrapMobile?: boolean;
};

export const Pillbox = (props: Props) => {
  const { children, wrap = true, wrapMobile = true, containerProps } = props;

  return (
    <StyledPillbox $wrap={wrap} $wrapMobile={wrapMobile} {...containerProps}>
      {children}
    </StyledPillbox>
  );
};

export const StyledPillbox = styled.div<{
  $wrap: boolean;
  $wrapMobile: boolean;
}>(
  p => css`
    display: flex;
    flex-wrap: ${p.$wrap ? 'wrap' : 'nowrap'};
    padding: 0 ${layout.measurements.spacingSmall} 0;
    margin-bottom: ${layout.measurements.spacingTiny};
    overflow-x: ${p.$wrap ? 'visible' : 'auto'};

    ${media.smallOnly`
      flex-wrap: ${p.$wrapMobile ? 'wrap' : 'nowrap'};
      overflow-x: ${p.$wrapMobile ? 'visible' : 'auto'};
    `};
  `
);
